import { createContext, useContext, useState } from 'react';

const FiltersSidebarContext = createContext();

export const FiltersSidebarProvider = ({ children }) => {
  const [productSidebarFilters, setProductSidebarFilters] = useState(null);
  const [portfolioSidebarFilters, setPortfolioSidebarFilters] = useState(null);

  const registerProductSidebarFilter = (data) => {
    setProductSidebarFilters(data);
  };

  const registerPortfolioSidebarFilter = (data) => {
    setPortfolioSidebarFilters(data);
  };

  const getProductSidebarFilter = () => {
    return productSidebarFilters;
  };

  const getPortfolioSidebarFilter = () => {
    return portfolioSidebarFilters;
  };

  return (
    <FiltersSidebarContext.Provider value={{ registerProductSidebarFilter, registerPortfolioSidebarFilter, getProductSidebarFilter, getPortfolioSidebarFilter }}>
      {children}
    </FiltersSidebarContext.Provider>
  );
};

export const useFiltersSidebar = () => useContext(FiltersSidebarContext);